import { render, staticRenderFns } from "./zoom.vue?vue&type=template&id=3ffc71d8&scoped=true&"
import script from "./zoom.vue?vue&type=script&lang=js&"
export * from "./zoom.vue?vue&type=script&lang=js&"
import style0 from "./zoom.vue?vue&type=style&index=0&id=3ffc71d8&prod&lang=css&"
import style1 from "./zoom.vue?vue&type=style&index=1&id=3ffc71d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffc71d8",
  null
  
)

export default component.exports